<template>
    <!-- <header class="masthead" :style="{ backgroundImage: 'url(' + pic + ')' }"> -->
    <header class="masthead" :style="{ backgroundImage: 'url(' + pic + ')' }">
        <div class="container position-relative px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8">
                    <div class="page-heading">
                        <h1>{{ title }}</h1>
                        <span class="subheading">{{ subtitle }}</span>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
<script setup>
// import pic from "img/background/background.jpg"
const pic = "http://img.helloworldend.top/background/background.jpg"

const prop = defineProps({
    title: {
        type: String,
        default: "print('hello, world_end!')"
    },
    subtitle: {
        type: String,
        default: "Null"
    }
})
</script>
